<template>
  <el-carousel :interval="4000" trigger="click" arrow="always" height="375px">
    <el-carousel-item v-for="item in imgList" :key="item.id">
      <a v-if="detail" :href="item.toUrl" target="_blank">
        <img :src='item.url' class="main-body-carousel-img" style="cursor: pointer" alt="pic"/>
      </a>
      <img v-else :src='item.url' class="main-body-carousel-img" alt="pic"/>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    imgList: Array,
    detail: Boolean,
  },
}
</script>

<style scoped>

.main-body-carousel-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

</style>